import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export const AvatarSkeleton = () => {
  return (
    <Stack
      direction='row'
      spacing={{ xs: 2, md: 4 }}
      alignItems='center'
      sx={{ width: '100%' }}
    >
      <Skeleton variant='circular' width={104} height={104} animation='wave' />
      <Box
        sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}
      >
        <Skeleton
          variant='text'
          width={'50%'}
          height={42}
          animation='wave'
          sx={{ transform: 'none' }}
        />
        <Skeleton
          variant='text'
          width={'80%'}
          height={22}
          animation='wave'
          sx={{ transform: 'none' }}
        />
        <Skeleton
          variant='text'
          width={'50%'}
          height={22}
          animation='wave'
          sx={{ transform: 'none' }}
        />
      </Box>
    </Stack>
  );
};
